import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/auth/Loginn";
import OpenRoute from "./components/Auth/OpenRoute";
import PrivateRoute from "./components/Auth/PrivateRoute";
import Signup from "./pages/auth/Signup";
import CreateEvent from "./pages/events/CreateEvent";
import Errorr from "./pages/404";
import Navbar from "./components/Auth/Navbar";
import RealTimeAttendees from "./pages/events/RealTimeAttendees";
import UpdateEvent from "./pages/events/UpdateEvent"; 
import EventDetails from "./pages/events/EventDetails";
import "./App.css";
function App() {
  return (
    <div className="main-container">
      <Navbar />
      <Routes>
        <Route
          path="/"
          element={

              <Home />

          }
        />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/login"
          element={
            <OpenRoute>
              <Login />
            </OpenRoute>
          }
        />
        <Route
          path="/signup"
          element={
            <OpenRoute>
              <Signup />
            </OpenRoute>
          }
        />
        <Route
          path="/create-event"
          element={
            <PrivateRoute>
              <CreateEvent />
            </PrivateRoute>
          }
        />
        <Route
          path="/real-time-attendees"
          element={
         
              <RealTimeAttendees />
            
          }
        />
        <Route
          path="/event/:eventId"
          element={
            <PrivateRoute>
              <EventDetails />
            </PrivateRoute>
          }
        />
         <Route path="/update-event/:eventId" element={<PrivateRoute><UpdateEvent /></PrivateRoute>} />
        <Route path="*" element={<Errorr />} />
      </Routes>
    </div>
  );
}

export default App;
